import React from 'react';
import {Table as ClassicTable} from './classic';
import {Table as SingleGameTable} from './single-game';

const PlayersList = {
    get(sportConfig) {
        if (sportConfig.isGameTypeSingleGame()) {
            return SingleGameTable;
        } else if (sportConfig.isGameTypeClassic()) {
            return ClassicTable;
        }

        throw new Error(`get ERR: unknown game type ${sportConfig.getGameType()}`);
    },
};

export {PlayersList};
